import React from 'react';
import './Textarea.css';

function Textarea({
  error = false,
  className = '',
  rows = 3,
  ...rest
}) {
  const classes = [
    'ui-textarea',
    error ? 'ui-textarea--error' : '',
    className,
  ].filter(Boolean).join(' ');
  return (
    <textarea
      className={classes}
      rows={rows}
      aria-invalid={error || undefined}
      {...rest}
    />
  );
}

export default Textarea;
